import { KeepAwake } from '@capacitor-community/keep-awake';
import { IonRouterOutlet, useIonViewWillEnter } from '@ionic/react';
import React, { memo, useEffect } from 'react';
import { matchPath, useLocation } from 'react-router';

import GuardedRoute from '../../components/router/GuardedRoute';
import Home from './mesh/Home';
import Maintenance from './mesh/Maintenance';
import MeshStatus from './mesh/MeshStatus';
import ProvisioningMacs from './mesh/ProvisioningMacs';
import SelectNetwork from './mesh/SelectNetwork';

const TabMesh: React.FC = memo(() => {
    const location = useLocation();

    useIonViewWillEnter(() => {
        KeepAwake.isSupported().then(async (result) => {
            if (result.isSupported) {
                await KeepAwake.keepAwake();
            }
        });
    });

    // useIonViewWillLeave(async () => {
    //     const result = await KeepAwake.isSupported();

    //     if (result.isSupported) {
    //         const result = await KeepAwake.isKeptAwake();
    //         if (result.isKeptAwake) {
    //             await KeepAwake.allowSleep();
    //         }
    //     }
    // });

    // TODO: work around because useIonViewWillLeave its not working
    // properly in nested routes
    // @see https://github.com/ionic-team/ionic-framework/issues/17992
    useEffect(() => {
        var init = async () => {
            const isInTabMesh = !!matchPath<{ jobId?: string }>(
                location.pathname,
                {
                    path: '/:jobId/installation/mesh',
                    exact: false,
                    strict: false,
                }
            );

            if (!isInTabMesh) {
                const result = await KeepAwake.isSupported();
                if (result.isSupported) {
                    const result = await KeepAwake.isKeptAwake();
                    if (result.isKeptAwake) {
                        await KeepAwake.allowSleep();
                    }
                }
            }
        };

        init();
    }, [location.pathname]);

    return (
        <IonRouterOutlet ionPage>
            <GuardedRoute
                exact
                path="/:jobId/installation/mesh"
                component={Home}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/mesh/maintenance"
                component={Maintenance}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/mesh/select-network"
                component={SelectNetwork}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/mesh/provisioning-macs"
                component={ProvisioningMacs}
            />
            <GuardedRoute
                exact
                path="/:jobId/installation/mesh/status"
                component={MeshStatus}
            />
        </IonRouterOutlet>
    );
});

export default TabMesh;
